/** Кэш списка критериев победы (сбрасывается после правок в WinCriteriaModal). */
let cachedRows = null

export function invalidateWinCriteriaCache() {
  cachedRows = null
}

export async function fetchUserWinCriteria(api, { force = false } = {}) {
  if (!force && cachedRows) return cachedRows
  const { data } = await api.get('/win-criteria/')
  const rows = Array.isArray(data) ? data : (data?.results ?? [])
  cachedRows = rows
  return rows
}

/** Хотя бы один критерий с непустым названием. */
export function userHasWinCriteria(rows) {
  if (!Array.isArray(rows)) return false
  return rows.some((r) => String(r?.name ?? '').trim().length > 0)
}

export async function checkWinCriteriaReady(api, { force = false } = {}) {
  const rows = await fetchUserWinCriteria(api, { force })
  return userHasWinCriteria(rows)
}

export function isWinCriteriaRequiredError(error) {
  const code = error?.response?.data?.code
  return code === 'win_criteria_required'
}
